export const Services = (props) => {
  return (
    <div id='services' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Goals and Plans</h2>
          <p>
           These are goals we've set to grow and improve Crisprcoin
          </p>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4'>
                  {' '}
                  <i className={d.icon}></i>
                  <div className='service-desc'>
                    <h3>{d.name}</h3>
                   <ol>
                    <li>{d.text}</li>
                    <li>{d.text1}</li>
                    <li>{d.text2}</li>
                    <li>{d.text3}</li>
                   </ol>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
